module.exports = __webpack_public_path__ + "media/icons/right-arrow-0bb61f72.png";